import { Skeleton } from '@workramp/ui';
import { FullWidthStack, SkeletonWrapper } from './LearnerAIQuestionAnswerSkeleton.styles';

export const LearnerAIQuestionAnswerSkeleton = () => (
  <FullWidthStack size={4}>
    <SkeletonWrapper>
      <Skeleton height={15} />
    </SkeletonWrapper>
    <SkeletonWrapper widthPercent={95}>
      <Skeleton height={15} />
    </SkeletonWrapper>
    <SkeletonWrapper>
      <Skeleton height={15} />
    </SkeletonWrapper>
    <SkeletonWrapper widthPercent={70}>
      <Skeleton height={15} />
    </SkeletonWrapper>
  </FullWidthStack>
);
